class @Classroom
  constructor: ->
    $('.content-block').find('i.fa-toggle-down, i.fa-toggle-up').on 'click', (e) ->
      $(this).closest('.content-block').find('[data-view]').slideToggle 'medium'

window.Classroom = @Classroom;
